import Component from '../classes/Component';
import api from "./instance";

export default function () {
    return new Component({
        name: 'api_search',
        requiredTargets: 'STAND_ALONE',
        onInit() {
            this.getCities = params => api({
                method: 'get',
                url: '/searchCities',
                params
            });

            this.getMetro = params => api({
                method: 'get',
                url: '/searchMetro',
                params
            })
        }
    })
}

